import React from 'react'
import GlobalLayout from '../layout/GlobalLayout'

export default function Home() {
    return (
        <GlobalLayout showTopMenu={false} >
            <div >Home</div>
        </GlobalLayout>

    )
}
